export default __webpack_public_path__ + "static/media/indian-spirit-logo.fcb28ee5.png";